import { MedicareAgentCollection } from '@/consent/medicare/domain/MedicareAgentCollection';
import { MedicareSettingsRepository } from '@/consent/medicare/domain/MedicareSettingsRepository';

export class MedicareSettingsMemory implements MedicareSettingsRepository {

  public async getAgents (): Promise <MedicareAgentCollection> {
    return new MedicareAgentCollection([{
      'key': 'jacob',
      'appointmentLink': 'https://calendly.com/insurance123/medicare',
      'aepLink': 'https://calendly.com/insurance123/aep-jacob'
    },
    {
      'key': 'zack',
      'appointmentLink': 'https://calendly.com/insurance12345/medicare',
      'aepLink': 'https://calendly.com/insurance12345/aep-zack'
    },
    {
      'key': 'kaleb',
      'appointmentLink': 'https://calendly.com/health-kaleb/medicare',
      'aepLink': 'https://calendly.com/health-kaleb/aep-kaleb'
    },
    {
      'key': 'david',
      'appointmentLink': 'https://calendly.com/david-healthforca/schedule-your-medicare-consultation-with-david',
      'aepLink': 'https://calendly.com/david-healthforca/aep-david'
    },
    {
      'key': 'eli',
      'appointmentLink': 'https://calendly.com/eli-healthforca/medicare-consultation-with-eli',
      'aepLink': 'https://calendly.com/eli-healthforca/aep-eli'
    }]);
  }

}
